import PageHeader from "@/components/layout/PageHeader";
import FaqSection from "@/components/home/FaqSection";

export default function Faq() {
  return (
    <>
      <PageHeader
        eyebrow="Frequently Asked"
        title="Answers to common FASTag questions."
        subtitle="Documents, activation timing, recharges, and delivery — the quick facts."
      />
      <FaqSection />
    </>
  );
}
